var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600px" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("customerDetails.codeDialog.createNewDiscountCode")
                )
              )
            ])
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                [
                  !_vm.codeCreated
                    ? [
                        _c(
                          "v-date-picker",
                          {
                            staticClass: "pm-10",
                            attrs: {
                              "full-width": "",
                              required: "",
                              range: ""
                            },
                            model: {
                              value: _vm.dates,
                              callback: function($$v) {
                                _vm.dates = $$v
                              },
                              expression: "dates"
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "", color: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.dates = []
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.clear")))]
                            ),
                            _c("v-spacer"),
                            _c("h3", { staticClass: "primary--text" }, [
                              _vm._v(_vm._s(_vm.validThroughText))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-radio-group",
                          {
                            attrs: { row: "" },
                            model: {
                              value: _vm.codeType,
                              callback: function($$v) {
                                _vm.codeType = $$v
                              },
                              expression: "codeType"
                            }
                          },
                          [
                            _c("v-radio", {
                              attrs: {
                                label: _vm.$t(
                                  "customerDetails.codeDialog.codeTypePercentage"
                                ),
                                value: "percentage"
                              }
                            }),
                            _c("v-radio", {
                              attrs: {
                                label: _vm.$t(
                                  "customerDetails.codeDialog.codeTypeFixed"
                                ),
                                value: "fixed"
                              }
                            })
                          ],
                          1
                        ),
                        _c("v-slider", {
                          staticClass: "mt-5",
                          attrs: {
                            color: "teal",
                            label: _vm.$t(
                              "customerDetails.codeDialog.discountValue"
                            ),
                            min: "1",
                            max: "100",
                            "thumb-label": "always",
                            "append-icon":
                              _vm.codeType === "percentage"
                                ? "mdi-percent"
                                : "mdi-currency-eur"
                          },
                          model: {
                            value: _vm.discountValue,
                            callback: function($$v) {
                              _vm.discountValue = $$v
                            },
                            expression: "discountValue"
                          }
                        }),
                        _c("v-combobox", {
                          staticClass: "mt-5",
                          attrs: {
                            hint: _vm.$t(
                              "customerDetails.codeDialog.userProvidedCodesHint"
                            ),
                            label: _vm.$t(
                              "customerDetails.codeDialog.userProvidedCodesLabel"
                            ),
                            multiple: "",
                            "persistent-hint": "",
                            chips: "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.userProvidedCodes,
                            callback: function($$v) {
                              _vm.userProvidedCodes = $$v
                            },
                            expression: "userProvidedCodes"
                          }
                        }),
                        _vm.userProvidedCodes.length < 1
                          ? _c("v-slider", {
                              staticClass: "mt-10",
                              attrs: {
                                color: "teal",
                                label: _vm.$t(
                                  "customerDetails.codeDialog.codesAmount"
                                ),
                                min: "1",
                                max: "250",
                                hint: _vm.$t(
                                  "customerDetails.codeDialog.codeGenerationHint"
                                ),
                                "thumb-label": "always"
                              },
                              model: {
                                value: _vm.codesAmount,
                                callback: function($$v) {
                                  _vm.codesAmount = $$v
                                },
                                expression: "codesAmount"
                              }
                            })
                          : _vm._e(),
                        _c(
                          "v-radio-group",
                          {
                            attrs: { row: "" },
                            model: {
                              value: _vm.codeUseType,
                              callback: function($$v) {
                                _vm.codeUseType = $$v
                              },
                              expression: "codeUseType"
                            }
                          },
                          [
                            _c("v-radio", {
                              attrs: {
                                label: _vm.$t(
                                  "customerDetails.codeDialog.infiniteUse"
                                ),
                                value: "infiniteUse"
                              }
                            }),
                            _c("v-radio", {
                              attrs: {
                                label: _vm.$t(
                                  "customerDetails.codeDialog.multipleUse"
                                ),
                                value: "multipleUse"
                              }
                            }),
                            _c("v-radio", {
                              attrs: {
                                label: _vm.$t(
                                  "customerDetails.codeDialog.singleUse"
                                ),
                                value: "singleUse"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.codeUseType === "multipleUse" ||
                        _vm.codeUseType === "infiniteUse"
                          ? _c("v-slider", {
                              staticClass: "mt-5",
                              attrs: {
                                color: "teal",
                                label: _vm.$t(
                                  "customerDetails.codeDialog.userMaxUseCount"
                                ),
                                min: "1",
                                max: "15",
                                hint: _vm.$t(
                                  "customerDetails.codeDialog.userMaxUseCountHint"
                                ),
                                "thumb-label": "always"
                              },
                              model: {
                                value: _vm.userMaxUseCount,
                                callback: function($$v) {
                                  _vm.userMaxUseCount = $$v
                                },
                                expression: "userMaxUseCount"
                              }
                            })
                          : _vm._e(),
                        _vm.codeUseType === "multipleUse"
                          ? _c("v-slider", {
                              staticClass: "mt-10 mb-5",
                              attrs: {
                                color: "teal",
                                label: _vm.$t(
                                  "customerDetails.codeDialog.codeMaxUseCount"
                                ),
                                min: "1",
                                max: "250",
                                hint: _vm.$t(
                                  "customerDetails.codeDialog.codeMaxUseCountHint"
                                ),
                                "thumb-label": "always"
                              },
                              model: {
                                value: _vm.codeMaxUseCount,
                                callback: function($$v) {
                                  _vm.codeMaxUseCount = $$v
                                },
                                expression: "codeMaxUseCount"
                              }
                            })
                          : _vm._e(),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              disabled: _vm.codeCreated
                            },
                            on: { click: _vm.create }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.create")))]
                        )
                      ]
                    : [
                        _c("h2", [_vm._v(_vm._s(_vm.createdCode))]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("customerDetails.codeDialog.pleaseCopy")
                            )
                          )
                        ]),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              disabled: !_vm.codeCreated
                            },
                            on: { click: _vm.close }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.close")))]
                        )
                      ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }